const bnplAccountPageStyles = {
  rootGrid: {
    height: '100%',
  },
  outerBox: {
    display: 'flex',
    width: '100%',
    mt: 5,
    paddingInline: 2,
  },
  innerBox: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '1%',
    maxWidth: { xs: '100%', md: '80%' },
    marginInline: 'auto',
  },
  activePurchasesHeaderRow: {
    display: 'flex',
    paddingInline: { xs: 2.5, md: 7.5 },
    marginBlock: 2.5,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  loanOverviewWrapper: {
    width: '100%',
  },
  childCardMaxWidth: {
    maxWidth: { xs: '100%' },
  },
};

export default bnplAccountPageStyles;
